/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, DialogTitle, DialogContentText } from "@mui/material";

export const StyledList = styled('ul')({
  paddingLeft: '20px',
  marginTop: '0',
  fontSize: '15px',
  color: '#5b5b5b',
  lineHeight: '24px',
  letterSpacing: '0.25px',
})

export const StyledDialogTitle = styled(DialogTitle)({
  fontWeight: '600',
  fontSize: '22px',
  padding: '13px 0px 5px 1px',
})

export const StyledDialogContentText = styled(DialogContentText)({
  fontSize: '15px',
  color: '#4f4f4f',
  marginBottom: '16px',
})

export const StyledSummaryCard = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: '10px',
  marginBottom: '14px',
  alignItems: 'stretch',
})

export const StyledSummaryItem = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  minHeight: '88px',
  padding: '14px 16px',
  boxSizing: 'border-box',
  borderRadius: '12px',
  backgroundColor: '#f7f8fa',
  border: '1px solid #e3e7ee',
})

export const StyledSummaryLabel = styled('div')({
  fontSize: '12px',
  fontWeight: 600,
  color: '#687385',
  letterSpacing: '0.4px',
  marginBottom: '2px',
})

export const StyledSummaryValue = styled('div')({
  fontSize: '22px',
  fontWeight: 700,
  color: '#1f2937',
  lineHeight: 1.2,
})

export const StyledErrorTitleContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  paddingLeft: '22px',
  justifyContent: 'space-between',
})

export const TitleContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
})

export const CloseIconContainer = styled('div')({
  paddingRight: '7px',
  cursor: 'pointer'
})

export const StyledFailedListHeading = styled('div')({
  fontSize: '14px',
  fontWeight: 600,
  color: '#374151',
  marginTop: '8px',
  marginBottom: '5px',
})
